<template>
  <div class="about-us">
    <menuBox :step="5"></menuBox>
    <div class="top-box">
      <div class="top-title">Contáctenos</div>
      <div class="top-content">
        CréditoÁgil / Contáctenos
      </div>
    </div>
    <div class="msg-box">
      <div class="title">
        Contáctenos
      </div>
      <div class="msg">
        Si está interesado en invertir con nosotros o necesita ayuda, no dude en contactarnos. Esperamos que a través de nuestros esfuerzos podamos ayudar a más personas a conseguir un futuro mejor.
      </div>
    </div>
    <div class="about-title">
      <div class="p-title">Contáctenos</div>
      <div class="p-subtitle">
        La inversión nunca se detiene
      </div>
      <div class="field-list">
        <div class="field-box">
          <div class="title">nombre<span>*</span></div>
          <input type="text" />
        </div>
        <div class="field-box">
          <div class="title">Correo electrónico<span>*</span></div>
          <input type="text" />
        </div>
        <div class="field-box">
          <div class="title">apellido del padre</div>
          <input type="text" />
        </div>
        <div class="field-box">
          <div class="title">Teléfono</div>
          <input type="text" />
        </div>
        <div class="field-box">
          <div class="title">mensaje</div>
          <textarea class="message" type="text"/>
        </div>
      </div>
      <div class="btn" @click="submit()">Enviando mensaje</div>
      <!-- <div class="info-box">
        <div class="title">
          GET IN TOUCH
        </div>
        <div class="content">
          Are you looking for an award-winning digital marketing campaign
          encompassing one or more of our services? Get in touch with a member
          of our expert team now!
        </div>
      </div>
      <div class="sub-box">
        <input type="text" placeholder="Your Name" />
        <input type="text" placeholder="Your Email" />
        <textarea class="message" type="text" placeholder="Message" />
        <div class="btn" @click="submit()">Get Appointment</div>
      </div> -->
    </div>

    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    submit() {
      alert("kirim sukses");
    },
  },
};
</script>
<style lang="less" scoped>
.top-box {
  height: 60px;
  background: #ce3723;
  padding: 0 360px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .top-title {
    font-size: 24px;
    font-family: Inter, Inter;
    font-weight: normal;
    color: #ffffff;
    line-height: 29px;
  }
  .top-content {
    font-size: 14px;
    font-family: Inter, Inter;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
  }
}
.msg-box {
  padding: 40px 360px;
  .title {
    font-size: 24px;
    font-family: Inter, Inter;
    font-weight: normal;
    color: #1e1e1e;
    line-height: 29px;
  }
  .msg {
    font-size: 12px;
    font-family: Inter, Inter;
    font-weight: 400;
    color: #959595;
    line-height: 14px;
    margin-top: 24px;
  }
}
.about-title {
  background: #f2f2f2;
  height: 820px;
  padding: 0 580px;
  overflow: hidden;
  .p-title {
    font-size: 32px;
    font-family: Inter, Inter;
    font-weight: normal;
    color: #1e1e1e;
    line-height: 38px;
    text-align: center;
    margin-top: 80px;
  }

  .p-subtitle {
    font-size: 16px;
    font-family: Inter, Inter;
    font-weight: 500;
    color: #ce3723;
    line-height: 19px;
    margin-top: 13px;
    text-align: center;
  }
  .field-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 32px;
    .field-box {
      .title {
        font-size: 14px;
        font-family: Inter, Inter;
        font-weight: 400;
        color: #1e1e1e;
        margin-bottom: 16px;
        span {
          color: #ce3723;
        }
      }
      input,
      textarea {
        background-color: #fff;
        width: 300px;
        padding: 0 20px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
        height: 48px;
        border: 1px solid #dddddd;
        margin-bottom: 20px;
      }
      .message {
        width: 700px;
        height: 200px;
        padding: 20px;
      }
    }
  }
  .btn {
    width: 150px;
    height: 44px;
    background: #ce3723;
    border-radius: 30px 30px 30px 30px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 44px;
    text-align: center;
  }
}
</style>
